<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-half">
        <p>QRコードをかざしてください</p>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-half">
        <canvas ref="canvas" id="canvas" hidden></canvas>
      </div>
      <video ref="video" id="video" width="480" autoplay hidden></video>
      <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
        style="background-color: rgba(0, 0, 0, 0.8)"
      ></b-loading>
    </div>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
  data() {
    return {
      qrcodeid: 'nil',
      isLoading: false,
    };
  },
  mounted() {
    const me = this;
    const router = this.$router;
    const video = this.$refs.video;
    const canvasElement = this.$refs.canvas;
    const canvas = this.$refs.canvas.getContext('2d');

    if (navigator.mediaDevices) {
      navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then((stream) => {
        video.srcObject = stream;
        video.setAttribute('playsinline', true);
        video.play();
        setTimeout(function () {
          requestAnimationFrame(tick);
        }, 100);
      });
    }
    function drawLine(begin, end, color) {
      canvas.beginPath();
      canvas.moveTo(begin.x, begin.y);
      canvas.lineTo(end.x, end.y);
      canvas.lineWidth = 4;
      canvas.strokeStyle = color;
      canvas.stroke();
    }
    function tick() {
      if (video.readyState != video.HAVE_ENOUGH_DATA) {
        setTimeout(function () {
          requestAnimationFrame(tick);
        }, 100);
        return;
      }

      canvasElement.hidden = false;
      canvasElement.width = video.videoWidth;
      canvasElement.height = video.videoHeight;
      canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
      var imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
      var code = window.jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert',
      });
      if (code) {
        drawLine(code.location.topLeftCorner, code.location.topRightCorner, '#FF3B58');
        drawLine(code.location.topRightCorner, code.location.bottomRightCorner, '#FF3B58');
        drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, '#FF3B58');
        drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, '#FF3B58');
        me.qrcodeid = code.data;
        authreq();
        return;
      }
      setTimeout(function () {
        requestAnimationFrame(tick);
      }, 500);
    }
    function authreq() {
      const apiService = new ApiService();
      // ローディング開始
      me.isLoading = true;
      apiService.checkQRCode(me.qrcodeid, (response) => {
        me.isLoading = false;
        if (response.status == 200) {
          me.$buefy.notification.open('QRコードの認識に成功しました');
          setTimeout(function () {
            router.push('/select-startstop?uid=' + me.qrcodeid);
          }, 1000);
        } else if (response.status == 401) {
          // トークン再取得失敗時にはログイン画面へ遷移
          me.$buefy.dialog.alert({
            message: 'ログインに失敗しました、管理者に再度ログインしてもらってください。',
            onConfirm: () => {
              me.$router.push('/admin_login');
            },
          });
        } else {
          me.$buefy.notification.open('不正なQRコードです。再度QRコードをかざしてください。');
          setTimeout(function () {
            requestAnimationFrame(tick);
          }, 500);
        }
      });
    }
  },
};
</script>

<style scoped>
.video {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Login.vue